module.exports = __webpack_public_path__ + "static/media/afsLogo.2034aba0.jpeg";